/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyQuestionModel } from '../../models/client-survey-question-model';
import { CreateSurveyQuestionRequest } from '../../models/create-survey-question-request';

export interface CreateSurveyquestion$Json$Params {
  
    /**
     * properties of new surveyquestion
     */
    body?: CreateSurveyQuestionRequest
}

export function createSurveyquestion$Json(http: HttpClient, rootUrl: string, params?: CreateSurveyquestion$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyquestion$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyQuestionModel>;
    })
  );
}

createSurveyquestion$Json.PATH = '/api/SurveyQuestion';
